import React, { useState } from "react";
import { Formulario } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { getUploadUrl } from "../../../../utils";
import { image } from "../../../../datos";

const formularioController = new Formulario();

const generoOptions = [
  { key: "m", text: "Masculino", value: "Masculino" },
  { key: "f", text: "Femenino", value: "Femenino" },
];

const estadoCivilOptions = [
  { key: "s", text: "Soltero", value: "soltero" },
  { key: "c", text: "Casado", value: "casado" },
  { key: "u", text: "Union Libre", value: "union_libre" },
  { key: "v", text: "Viudo", value: "viudo" },
];

const licenciaOptions = [
  { key: "no", text: "No", value: "no" },
  { key: "2", text: "Cat 2", value: "2" },
  { key: "3", text: "Cat 3", value: "3" },
  { key: "4", text: "Cat 4", value: "4" },
];

const vehiculoOptions = [
  { key: "s", text: "Si", value: "si" },
  { key: "n", text: "No", value: "no" },
];

export function EditDocumentoModal({ formulario, onClose, onReload }) {
  const { accessToken } = useAuth();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [form, setForm] = useState({
    nombre: formulario.nombre || "",
    apellido: formulario.apellido || "",
    documento_identidad: formulario.documento_identidad || "",
    correo_electronico: formulario.correo_electronico || "",
    telefono1: formulario.telefono1 || "",
    telefono2: formulario.telefono2 || "",
    genero: formulario.genero || "",
    estado_civil: formulario.estado_civil || "",
    fecha_nacimiento: formulario.fecha_nacimiento || "",
    licencia_tiene: formulario.licencia_tiene || "",
    categoria_licencia: formulario.categoria_licencia || "",
    vehiculo_propio: formulario.vehiculo_propio || "",
    direccion: formulario.direccion || "",
    sector_barrio: formulario.sector_barrio || "",
    ciudad: formulario.ciudad || "",
    area_interes: formulario.area_interes || "",
  });
  const [fileDocument, setFileDocument] = useState(null);
  const [fileAvatar, setFileAvatar] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (name, value) => {
    setForm({ ...form, [name]: value });
  };

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    if (type === "document") {
      const allowed = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
      if (!allowed.includes(file.type)) {
        setError("Solo se permiten archivos PDF o DOCX");
        return;
      }
      setFileDocument(file);
    } else {
      const allowed = ["image/jpeg", "image/png", "image/webp"];
      if (!allowed.includes(file.type)) {
        setError("Solo se permiten archivos JPG, PNG o WEBP");
        return;
      }
      setFileAvatar(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");

    try {
      const data = { ...form };
      if (fileDocument) data.fileDocument = fileDocument;
      if (fileAvatar) data.fileAvatar = fileAvatar;

      await formularioController.updateDocumento(accessToken, formulario.id, data);
      onReload();
      onClose();
    } catch (err) {
      setError(err.message || "Error al guardar");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-h-[70vh] overflow-y-auto pr-2">
      <form onSubmit={handleSubmit} className="space-y-6">
        {error && (
          <div className="p-3 bg-red-50 border border-red-200 rounded-xl text-red-700 text-sm">
            {error}
          </div>
        )}

        {/* Avatar Preview */}
        <div className="flex items-center gap-4">
          <div className="relative">
            <img
              src={
                fileAvatar
                  ? URL.createObjectURL(fileAvatar)
                  : formulario.fileAvatar
                  ? getUploadUrl(formulario.fileAvatar)
                  : image.noAvatar
              }
              alt="Avatar"
              className="w-16 h-16 rounded-full object-cover border-2 border-gray-200"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Foto de perfil</label>
            <input
              type="file"
              accept=".jpg,.jpeg,.png,.webp"
              onChange={(e) => handleFileChange(e, "avatar")}
              className="text-sm text-gray-500 file:mr-3 file:py-1 file:px-3 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-[#1F2937]/10 file:text-[#1F2937] hover:file:bg-[#1F2937]/20"
            />
          </div>
        </div>

        {/* Personal Info */}
        <div>
          <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-3">Informacion Personal</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Nombre *</label>
              <input
                type="text"
                name="nombre"
                value={form.nombre}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1F2937]/20 focus:border-[#1F2937] outline-none transition-all"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Apellido</label>
              <input
                type="text"
                name="apellido"
                value={form.apellido}
                onChange={handleChange}
                className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1F2937]/20 focus:border-[#1F2937] outline-none transition-all"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Documento de Identidad</label>
              <input
                type="text"
                name="documento_identidad"
                value={form.documento_identidad}
                onChange={handleChange}
                className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1F2937]/20 focus:border-[#1F2937] outline-none transition-all"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Correo Electronico</label>
              <input
                type="email"
                name="correo_electronico"
                value={form.correo_electronico}
                onChange={handleChange}
                className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1F2937]/20 focus:border-[#1F2937] outline-none transition-all"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Telefono</label>
              <input
                type="text"
                name="telefono1"
                value={form.telefono1}
                onChange={handleChange}
                className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1F2937]/20 focus:border-[#1F2937] outline-none transition-all"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Movil</label>
              <input
                type="text"
                name="telefono2"
                value={form.telefono2}
                onChange={handleChange}
                className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1F2937]/20 focus:border-[#1F2937] outline-none transition-all"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Genero</label>
              <select
                name="genero"
                value={form.genero}
                onChange={(e) => handleSelectChange("genero", e.target.value)}
                className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1F2937]/20 focus:border-[#1F2937] outline-none transition-all"
              >
                <option value="">Seleccionar</option>
                {generoOptions.map((o) => (
                  <option key={o.key} value={o.value}>{o.text}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Estado Civil</label>
              <select
                name="estado_civil"
                value={form.estado_civil}
                onChange={(e) => handleSelectChange("estado_civil", e.target.value)}
                className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1F2937]/20 focus:border-[#1F2937] outline-none transition-all"
              >
                <option value="">Seleccionar</option>
                {estadoCivilOptions.map((o) => (
                  <option key={o.key} value={o.value}>{o.text}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Fecha de Nacimiento</label>
              <input
                type="date"
                name="fecha_nacimiento"
                value={form.fecha_nacimiento}
                onChange={handleChange}
                className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1F2937]/20 focus:border-[#1F2937] outline-none transition-all"
              />
            </div>
          </div>
        </div>

        {/* License & Vehicle */}
        <div>
          <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-3">Licencia y Vehiculo</h4>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Licencia</label>
              <select
                name="licencia_tiene"
                value={form.licencia_tiene}
                onChange={(e) => handleSelectChange("licencia_tiene", e.target.value)}
                className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1F2937]/20 focus:border-[#1F2937] outline-none transition-all"
              >
                <option value="">Seleccionar</option>
                {licenciaOptions.map((o) => (
                  <option key={o.key} value={o.value}>{o.text}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Categoria</label>
              <input
                type="text"
                name="categoria_licencia"
                value={form.categoria_licencia}
                onChange={handleChange}
                className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1F2937]/20 focus:border-[#1F2937] outline-none transition-all"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Vehiculo Propio</label>
              <select
                name="vehiculo_propio"
                value={form.vehiculo_propio}
                onChange={(e) => handleSelectChange("vehiculo_propio", e.target.value)}
                className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1F2937]/20 focus:border-[#1F2937] outline-none transition-all"
              >
                <option value="">Seleccionar</option>
                {vehiculoOptions.map((o) => (
                  <option key={o.key} value={o.value}>{o.text}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Address */}
        <div>
          <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-3">Direccion</h4>
          <div className="grid grid-cols-1 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Direccion</label>
              <input
                type="text"
                name="direccion"
                value={form.direccion}
                onChange={handleChange}
                className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1F2937]/20 focus:border-[#1F2937] outline-none transition-all"
              />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Sector / Barrio</label>
                <input
                  type="text"
                  name="sector_barrio"
                  value={form.sector_barrio}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1F2937]/20 focus:border-[#1F2937] outline-none transition-all"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Ciudad</label>
                <input
                  type="text"
                  name="ciudad"
                  value={form.ciudad}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1F2937]/20 focus:border-[#1F2937] outline-none transition-all"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Area de Interes */}
        <div>
          <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-3">Area de Interes</h4>
          <input
            type="text"
            name="area_interes"
            value={form.area_interes}
            onChange={handleChange}
            placeholder="Ej: logistica, ventas, tecnologia..."
            className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1F2937]/20 focus:border-[#1F2937] outline-none transition-all"
          />
        </div>

        {/* Document Upload */}
        <div>
          <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-3">Documento CV</h4>
          <div className="flex items-center gap-4">
            {formulario.fileDocument && !fileDocument && (
              <a
                href={getUploadUrl(formulario.fileDocument)}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-[#1F2937] hover:underline flex items-center gap-1"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                Ver documento actual
              </a>
            )}
            {fileDocument && (
              <span className="text-sm text-green-600 flex items-center gap-1">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Nuevo archivo: {fileDocument.name}
              </span>
            )}
          </div>
          <input
            type="file"
            accept=".pdf,.doc,.docx"
            onChange={(e) => handleFileChange(e, "document")}
            className="mt-2 text-sm text-gray-500 file:mr-3 file:py-1 file:px-3 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-[#1F2937]/10 file:text-[#1F2937] hover:file:bg-[#1F2937]/20"
          />
        </div>

        {/* Actions */}
        <div className="flex gap-3 pt-4 border-t border-gray-200">
          <button
            type="submit"
            disabled={saving}
            className="flex-1 py-3 bg-gray-900 text-white rounded-xl font-medium hover:bg-gray-900/90 transition-all duration-300 flex items-center justify-center gap-2 disabled:opacity-50"
          >
            {saving ? (
              <>
                <svg className="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Guardando...
              </>
            ) : (
              <>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Guardar Cambios
              </>
            )}
          </button>
          <button
            type="button"
            onClick={onClose}
            className="px-6 py-3 bg-gray-200 text-gray-700 rounded-xl font-medium hover:bg-gray-300 transition-all duration-300"
          >
            Cancelar
          </button>
        </div>
      </form>
    </div>
  );
}
